module.exports = __webpack_public_path__ + "img/close.1eca0c54.svg";